import { render, staticRenderFns } from "./SchemaFormModal.vue?vue&type=template&id=3dda2c72&"
import script from "./SchemaFormModal.vue?vue&type=script&lang=js&"
export * from "./SchemaFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports